import { render, staticRenderFns } from "./ProfileWrapper.vue?vue&type=template&id=11293639&scoped=true&"
import script from "./ProfileWrapper.vue?vue&type=script&lang=js&"
export * from "./ProfileWrapper.vue?vue&type=script&lang=js&"
import style0 from "./ProfileWrapper.vue?vue&type=style&index=0&id=11293639&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11293639",
  null
  
)

export default component.exports